<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <topIcon  :template="dominItem.templateId"  :nationId="dominItem.nationId" noAbout="noAbout"></topIcon>
    </div>
    <div>
      <div class="category" :class="`${dominItem.templateId}`" v-if="dominItem.templateId === 'temp1'">
        <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
      <div class="category" :class="`${dominItem.templateId}`" v-else>
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
        <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
      </div>
    </div>

    <div>
      <div class="business-page" style="background: #fff">
        <div style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
          <h1 class="section-title">{{ $t('con_recommended') }}</h1>
          <div class="line"></div>
        </div>
        <div style="display: flex">
          <!-- 左侧编辑推荐栏 -->
          <div class="sidebar">
            <div class="editors-picks">
              <h2>{{ $t('con_hot_con') }}</h2>
              <div class="sidebar-article" v-for="item in latestNewsList" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="news-article-img"
                >
                <h3  class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
          <!-- 右侧主要内容区 -->
          <div class="main-content">
            <div class="featured-article" @click="toDetail(bestItem.articleShortName)">
              <img :src="bestItem.articleImage" class="main-article-img" >
              <h2 class="twoHde">{{ bestItem.articleTitle }}</h2>
              <p class="threeHde">
                {{ bestItem.articleIntro }}
              </p>
            </div>

            <div class="article-grid">
              <div class="grid-article" v-for="item in articleList" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="sub-article-img"
                >
                <h3 class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="business-page">
        <div style="display: flex; align-items: center; gap: 20px">
          <h1 class="section-title">{{ $t('con_related') }}</h1>
          <div class="line"></div>
        </div>
        <div style="display: flex">

          <!-- 右侧主要内容区 -->
          <div class="main-content">
            <div class="article-grid">
              <div class="grid-article" v-for="item in recommendList1" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="article-img"
                >
                <h3 class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
          <!-- 左侧编辑推荐栏 -->
          <div class="sidebar">
            <div class="editors-picks">
              <h2>{{ $t('con_latest') }}</h2>
              <div class="sidebar-article" v-for="item in recommendList" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="article-img"
                >
                <h3 class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="business-page" style="background: #fff">
        <div style="display: flex; align-items: center; gap: 20px">
          <h1 class="section-title">{{ $t('con_bestnew') }}</h1>
          <div class="line"></div>
        </div>
        <div style="display: flex">
          <!-- 左侧编辑推荐栏 -->
          <div class="sidebar">
            <div class="editors-picks">
<!--              <h2>EDITORS' TOP PICKS</h2>-->
              <div class="sidebar-article" v-for="item in latestNewsList1" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="article-img"
                >
                <h3 class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
          <!-- 右侧主要内容区 -->
          <div class="main-content">
            <div class="article-grid">
              <div class="grid-article" v-for="item in recommendList2" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="article-img"
                >
                <h3 class="twoHde">{{ item.articleTitle }}</h3>
                <p class="threeHde">{{ item.articleIntro }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>



    <div class="buttom">
      <div class="line1">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="logo" style="color: #fff">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>
        </div>
        <img style="width: 30px; height: 30px "  v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">

      </div>
</div>
      <footers :articleListlast="articleListlast" :nationId="dominItem.nationId" :current="current" is00="is00"></footers>

    </div>
  </div>
</template>

<script>
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"
import {getContentList, getLatestNews, getOne, getRecommend} from "@/api";

export default {


  components: {topIcon, buttomIcon, footers},
  props: {
    dominItem: Object
  },
  name: "index",
  data() {
    return {
      bestItem: {},
      recommendList1: [],
      latestNewsList:[],
      articleList: [],
      articleListlast:[],
      recommendList:[],
      latestNewsList1:[],
      recommendList2:[],
      nodata: false,
      template: 'temp2',
      current: 1,
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],

      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    openLink(link) {
      window.open(link)
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },

    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList1() {
      getLatestNews({articleCategoryId: this.current, pageNum: 2, pageSize: 2, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    getRecommendList2() {
      getRecommend({articleCategoryId: this.current, pageNum: 2, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList2 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.business-page {
  padding: 20px 20%;
  background-color: #f9f3e6;

  .line {
    width: 100%;
    border: 1px solid #000000;
  }

  .section-title {
    min-width: 400px;
  }

  // 模拟页面浅黄色背景，可根据实际需求调整
  .sidebar {
    width: 30%;

    .section-title {

      font-size: 28px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .editors-picks {
      background-color: #fff;
      padding: 15px;
      margin-bottom: 20px;

      h2 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        background-color: #000;
        color: #fff;
        display: inline-block;
        padding: 5px 10px;
        width: 100%;
        text-align: center;
      }

      .sidebar-article {
        margin-bottom: 20px;
        border-bottom: 1px solid #000000;
        padding-bottom: 10px;


        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-bottom: 10px;
        }

        h3 {
          font-size: 16px;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        p {
          font-size: 14px;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
    }
  }

  .main-content {
    width: 70%;
    padding: 0 20px;

    .featured-article {
      margin-bottom: 20px;

      img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
      }

      h2 {
        font-size: 22px;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        line-height: 1.4;
      }
    }

    .article-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;

      .grid-article {
        background-color: #fff;
        padding: 10px;

        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-bottom: 10px;
        }

        h3 {
          font-size: 16px;
          margin-bottom: 5px;
        }

        p {
          font-size: 14px;
          line-height: 1.4;
        }
      }
    }
  }
}

.business-title {
  background-color: #003366;
  color: white;
  text-align: center;
  width: 130px;
  margin-bottom: 20px;
}

.logo {
  padding: 10px;
  box-sizing: border-box;
  font-size: 40px;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 15%;
  min-height: 50px;
  background: #000;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 500;
    font-size: 14px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    border-bottom: 3px solid #D4AF37;
    color: #D4AF37;
    transition: all .1s ease;
  }

  .choose {
    border-bottom: 3px solid #D4AF37;
    transition: all .1s ease;
    color: #D4AF37;
  }
}

.buttom {
  width: 100%;
  background: #000;
  display: flex;
  flex-direction: column;
  border: 1px solid #000000;

  .logo {
    width: auto;
  }
  display: flex;
  .explore {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 30px;
    margin-bottom: 30px;
    span {
      margin-right: 10px;
      text-align: center;
      font-size: 15px;
      color: #A6AEB1;
      display: inline-block;
      width: 20%;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.temp1, .temp2, .temp3 {
  justify-content: space-between;
}

.line1 {
  width: 80%;
  border-bottom: 1px solid #838383;
  margin: 0 10% 20px;
}

.article-img {
  height: 200px;
  width: 100%;
  object-fit: cover;
}
</style>